import React, { useEffect, useState } from "react";
import { BASE_URL } from "../config/api";
import { useNavigate, useParams } from "react-router-dom";

const EditPlating = () => {
  const [formData, setFormData] = useState({
    staff_id: "",
    customer_name: "",
    net_weight_of_gold: "",
    description: "",
    pcs: "",
    laker: "",
    image: null,
  });

  const [staffList, setStaffList] = useState([]);
  const [error, setError] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetchStaffList();
    fetchPlatingRecord();
  }, [id]);

  const fetchStaffList = async () => {
    try {
      const response = await fetch("https://pbhrm.com/api/staff");
      const data = await response.json();
      if (data.status === 1) {
        setStaffList(data.data);
      }
    } catch (err) {
      console.error("Error fetching staff list:", err);
    }
  };

  const fetchPlatingRecord = async () => {
    try {
      const response = await fetch(`${BASE_URL}plating/${id}`);
      const data = await response.json();

      console.log("Full API response:", data);

      if (data.status === 1) {
        const plating = data.data;
        console.log("Plating data:", plating);
        console.log("Image data:", plating.image);

        setFormData({
          staff_id: plating.staff_id || "",
          customer_name: plating.customer_name || "",
          net_weight_of_gold: plating.net_weight_of_gold || "",
          description: plating.description || "",
          pcs: plating.pcs || "",
          laker: plating.laker || "",
          image: null,
        });

        // FIXED: Proper image URL construction
        if (plating.image) {
          try {
            console.log("Raw image string:", plating.image);

            let imagePath = plating.image;

            // Try to parse as JSON array
            try {
              const parsed = JSON.parse(plating.image);
              if (Array.isArray(parsed) && parsed.length > 0) {
                imagePath = parsed[0];
                console.log("Parsed image path:", imagePath);
              }
            } catch (parseError) {
              console.log("Image is not JSON, using as string");
            }

            // Clean the path - remove backslashes
            const cleanPath = imagePath.replace(/\\/g, "/");
            console.log("Cleaned path:", cleanPath);

            // Construct the correct image URL
            // Use the main domain directly since BASE_URL might be for API only
            const domain = "https://pbhrm.com";

            // Remove any leading slashes from the path
            const finalPath = cleanPath.replace(/^\/+/, "");

            // Construct full URL
            const imageUrl = `${domain}/${finalPath}`;

            console.log("Final image URL:", imageUrl);

            // Test if image exists
            const img = new Image();
            img.onload = () => {
              console.log("✅ Image loaded successfully");
              setImagePreview(imageUrl);
            };
            img.onerror = () => {
              console.log("❌ Image failed to load, trying alternative URL");
              // Try alternative URL structure
              const alternativeUrl = `${domain}/uploads/${finalPath
                .split("/")
                .pop()}`;
              console.log("Alternative URL:", alternativeUrl);
              setImagePreview(alternativeUrl);
            };
            img.src = imageUrl;
          } catch (error) {
            console.error("Error processing image:", error);
          }
        } else {
          console.log("No image found in record");
        }
      } else {
        setError("Failed to fetch plating record");
      }
    } catch (error) {
      console.error("Error fetching plating record:", error);
      setError("An error occurred while fetching the plating record");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        image: file,
      }));

      // Create preview for new image
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      staff_id,
      customer_name,
      net_weight_of_gold,
      description,
      pcs,
      laker,
      image,
    } = formData;

    if (
      !staff_id ||
      !customer_name ||
      !net_weight_of_gold ||
      !description ||
      !pcs ||
      !laker
    ) {
      setError("All fields are required");
      return;
    }

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("staff_id", staff_id);
    formDataToSubmit.append("customer_name", customer_name);
    formDataToSubmit.append("net_weight_of_gold", net_weight_of_gold);
    formDataToSubmit.append("description", description);
    formDataToSubmit.append("pcs", pcs);
    formDataToSubmit.append("laker", laker);

    // Only append image if a new one was selected
    if (image instanceof File) {
      formDataToSubmit.append("image", image);
    }

    try {
      const response = await fetch(`${BASE_URL}plating/${id}`, {
        method: "PUT",
        body: formDataToSubmit,
      });
      const data = await response.json();

      if (data.status === 1) {
        navigate("/PlatingList");
      } else {
        setError(data.error || "Something went wrong");
      }
    } catch (error) {
      console.error("Error updating plating:", error);
      setError("An error occurred while updating plating");
    }
  };

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <h3>Edit Plating Record</h3>
        </div>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                {error && <div className="alert alert-danger">{error}</div>}
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="staff_id" className="form-label">
                      Staff
                    </label>
                    <select
                      className="form-control"
                      id="staff_id"
                      name="staff_id"
                      value={formData.staff_id}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Staff</option>
                      {staffList.map((staff) => (
                        <option key={staff.id} value={staff.id}>
                          {staff.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="customer_name" className="form-label">
                      Customer Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="customer_name"
                      name="customer_name"
                      value={formData.customer_name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="net_weight_of_gold" className="form-label">
                      Net Weight of Gold
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="net_weight_of_gold"
                      name="net_weight_of_gold"
                      value={formData.net_weight_of_gold}
                      onChange={handleChange}
                      step="0.01"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Rhodium
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="description"
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      step="0.01"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="pcs" className="form-label">
                      Flash
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="pcs"
                      name="pcs"
                      value={formData.pcs}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="laker" className="form-label">
                      Laker
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="laker"
                      name="laker"
                      value={formData.laker}
                      onChange={handleChange}
                      step="0.01"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="image" className="form-label">
                      Image
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="image"
                      name="image"
                      accept="image/*"
                      onChange={handleImageChange}
                    />

                    {/* Image Preview */}
                    {imagePreview ? (
                      <div className="mt-2">
                        <img
                          src={imagePreview}
                          alt="Plating Preview"
                          style={{
                            width: "200px",
                            height: "200px",
                            objectFit: "cover",
                            border: "2px solid #007bff",
                            borderRadius: "8px",
                            padding: "4px",
                          }}
                          onError={(e) => {
                            console.error(
                              "Image failed to load:",
                              imagePreview
                            );
                            e.target.style.display = "none";
                            // Show the URL that failed for debugging
                            const errorMsg = document.createElement("div");
                            errorMsg.className = "alert alert-warning mt-2";
                            errorMsg.innerHTML = `
                                                            <strong>Image not found!</strong><br>
                                                            URL: ${imagePreview}<br>
                                                            Please check if the image exists on the server.
                                                        `;
                            e.target.parentNode.appendChild(errorMsg);
                          }}
                        />
                        <div className="mt-1">
                          <small className="text-success">
                            <strong>
                              {formData.image instanceof File
                                ? "New Image Preview"
                                : "Current Image"}
                            </strong>
                          </small>
                        </div>
                      </div>
                    ) : (
                      <div className="mt-2">
                        <small className="text-muted">No image available</small>
                      </div>
                    )}
                  </div>

                  <div className="d-flex gap-2">
                    <button type="submit" className="btn btn-primary">
                      Update Plating
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => navigate("/PlatingList")}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditPlating;
